import { numberConvert } from "@website/utils/number-convert";

export type AccommodationCardReservationInfoProperties = {
  guestsCount: number;
  nightCount: number;
};

export const AccommodationCardReservationInfo: React.FC<
  AccommodationCardReservationInfoProperties
> = ({ guestsCount, nightCount }) => {
  const shouldShowFromPerNight = guestsCount > 0 && nightCount > 0;
  return (
    <>
      <span className="text-on-surface-high-emphasis text-extra-caption whitespace-nowrap font-[400]">
        {shouldShowFromPerNight
          ? `${numberConvert(guestsCount, {
              locale: "fa"
            })} نفر و ${numberConvert(nightCount, {
              locale: "fa"
            })} شب`
          : " قیمت از شبی"}
      </span>
    </>
  );
};
